export default middlewares => async (ctx, next) => {
  const reversedMiddlewares = []
  for (let i = middlewares.length - 1; i >= 0; i--) {
    reversedMiddlewares.push(middlewares[i])
  }
  const launch = reversedMiddlewares.reduce((n, middleware) => {
    return () => middleware(ctx, n)
  }, next)

  await launch()
}
